import { useCallback, useState, useMemo, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, makeStyles, Tab, Tabs as ScrollTabs, Button, withStyles } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { KeyboardDatePicker as MUIKeyboardDatePicker } from '@material-ui/pickers';
import { classNames } from '../../../utils';
import { TELEVISIT_STATUS, TELEVISIT_ROBOT_STATUS } from '../../../comm/constant';
import DiaLog from '../../../components/Dialog';
import { i18n } from '../../../language';
import { SearchIcon, DateIcon } from '../../../components/Icon';
import StyleButton from '../../../components/StyleButton';
import { teleVisitAPI } from '../../../apis';
import TimeInput from '../../Setting/components/Tele/Popup/Field/TimeInput';
import AutoCompleteSelect from '../../../components/AutoCompleteSelect';
import RobotImg from '../../../static/images/robot2.png';

import TimeslotDetail from './TimesLotDetail';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      <Box p={3}>{children}</Box>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const contentStyle = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  cardInfoId: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    lineHeight: '1.5rem',
  },
  cardInfoHocFlag: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    lineHeight: '1.5rem',
    textTransform: 'none',
  },
  cardInfoName: {
    fontFamily: 'NotoSans-Bold',
    maxWidth: '15rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1.175rem',
  },
  textTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.9rem',
    paddingRight: 10,
    width: '8rem',
    textTransform: 'none',
  },
  textContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.9rem',
    alignItems: 'center',
    gridGap: '0.5rem',
    wordBreak: 'break-word',
    textTransform: 'none',
  },
}));
const Content = ({ item, sytemNameMaping }) => {
  const classes = contentStyle({});

  const date = useMemo(() => {
    const timeslotDate = moment(Number(item.timeslotDate)).format('YYYY-MM-DD');
    const timeslotEndDate = item.timeslotEndDate ? `${moment(Number(item.timeslotEndDate)).format('YYYY-MM-DD')} ` : '';
    if (timeslotEndDate !== '') {
      return `${timeslotDate || ''}  ${item.startTime || ''}  -  ${timeslotEndDate}${item.endTime || ''}`;
    }
    return `${timeslotDate || ''}      ${item.startTime || ''}  -  ${item.endTime || ''}`;
  }, [item]);

  const status = useMemo(() => {
    let statusText = '';
    switch (item.timeslotBookingStatusEnum) {
      case TELEVISIT_STATUS.CONFIRMED:
        statusText = i18n.t('TELEVISIT_CONFIRMED_SCHEDULED');
        break;
      case TELEVISIT_STATUS.INPROGRESS:
        statusText = i18n.t('TELEVISIT_VISIT_IN_PROGRESS');
        break;
      case TELEVISIT_STATUS.COMPLETED:
        statusText = i18n.t('TELEVISIT_VISIT_COMPLETED');
        break;
      case TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING:
        statusText = i18n.t('TELEVISIT_ROBOT_STARTS_PROCESS_THE_BOOKING');
        break;
      case TELEVISIT_STATUS.AVAILABLE:
        statusText = i18n.t('TELEVISIT_AVAILABLE');
        break;
      case TELEVISIT_STATUS.RESERVED:
        statusText = i18n.t('TELEVISIT_VERIFYING');
        break;
      case TELEVISIT_STATUS.UNAVAILABLE:
        statusText = i18n.t('TELEVISIT_UNAVAILABLE');
        break;
      case TELEVISIT_STATUS.CANCEL:
        statusText = i18n.t('TELEVISIT_CANCELLED');
        break;
      case TELEVISIT_STATUS.COMPLETED_MANUALLY:
        statusText = i18n.t('TELEVISIT_VISIT_COMPLETED_MANUALLY');
        break;
      case TELEVISIT_STATUS.REJECTED:
        statusText = i18n.t('TELEVISIT_VISIT_REJECTED');
        break;
      default:
        break;
    }
    return statusText;
  }, [item]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      minHeight="5rem"
      p="0rem"
      pb="0.5rem"
      style={{ textAlign: 'left' }}
      borderBottom="solid 1px #e4e7eb"
    >
      <Box display="flex" justifyContent="space-between">
        <Box className={classes.cardInfoId}>{item.bedNo}</Box>
        <Box className={classes.cardInfoHocFlag}>{item.hocFlag === 1 ? i18n.t('TELEVISIT_ADHOC_FLAG') : ''}</Box>
      </Box>
      <div className={classes.cardInfoName}>
        {[item.patientNameEn, item.patientNameCh].filter((item) => item).join(', ')}
      </div>
      <Box display="flex">
        <Box marginRight="0.313rem" display="flex" alignItems="center">
          <AccessTimeIcon style={{ height: '1.25rem', width: '1.25rem' }} />
        </Box>
        <div className={classes.time}>{date}</div>
      </Box>

      <Box display="flex" mt="0.5rem">
        <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
          {i18n.t('TELEVISIT_ADVANCE_SEARCH_REF')}
        </Box>
        <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
          {item.bookId}
        </Box>
      </Box>
      <Box display="flex">
        <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
          {i18n.t('TELEVISIT_POPUP_STATUS')}
        </Box>
        <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
          <div dangerouslySetInnerHTML={{ __html: typeof status === 'string' ? status : '' }} />
        </Box>
      </Box>

      {/* for cancelled status */}
      {item.timeslotBookingStatusEnum === TELEVISIT_STATUS.CANCEL && (
        <>
          {item.cancelFrom === 'WP' && (
            <Box display="flex">
              <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
                {i18n.t('TELEVISIT_CANCLE_LIST_CANCEL_SOURCE')}
              </Box>
              <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
                <span>{item.cancelBy}</span>
              </Box>
            </Box>
          )}
          <Box display="flex">
            <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
              {i18n.t('TELEVISIT_CANCLE_LIST_CANCEL_FROM')}
            </Box>
            <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
              {sytemNameMaping(item.cancelFrom)}
            </Box>
          </Box>
          <Box display="flex">
            <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
              {i18n.t('TELEVISIT_CANCLE_LIST_CANCEL_TIME')}
            </Box>
            <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
              {moment(item.cancelDate, 'x').format('YYYY-MM-DD HH:mm')}
            </Box>
          </Box>
        </>
      )}

      {/* for other status */}
      {item.timeslotBookingStatusEnum !== TELEVISIT_STATUS.CANCEL && (
        <>
          {/* {item.cancelFrom === 'WP' && ( */}
          <Box display="flex">
            <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
              {i18n.t('TELEVISIT_ADVANCE_SEARCH_BOOKING_BY')}
            </Box>
            <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
              <span>{item.bookingBy}</span>
            </Box>
          </Box>
          {/* )} */}
          <Box display="flex">
            <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
              {i18n.t('TELEVISIT_ADVANCE_SEARCH_BOOKING_FROM')}
            </Box>
            <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
              {sytemNameMaping(item.bookingSource)}
            </Box>
          </Box>
          <Box display="flex">
            <Box className={classes.textTitle} flexDirection="column" flexBasis="65%">
              {i18n.t('TELEVISIT_POPUP_APPLICATION_TIME')}
            </Box>
            <Box className={classes.textContent} flexDirection="column" flexBasis="62%">
              {moment(item.applicationTime, 'x').format('YYYY-MM-DD HH:mm')}
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

const searchBarStyle = makeStyles((theme) => ({
  timeInput: {
    '& .MuiAutocomplete-root': {
      width: '100%',
      border: '1px solid rgb(228, 231, 235)',
      position: 'relative',
      background: 'rgb(255, 255, 255)',
      borderRadius: '0.625rem',
      '& div': {
        border: 'none',
      },
    },
  },
  timeInputError: {
    '& .MuiAutocomplete-root': {
      width: '100%',
      border: '1px solid rgb(244, 67, 54)',
      position: 'relative',
      background: 'rgb(255, 255, 255)',
      borderRadius: '0.625rem',
      '& div': {
        border: 'none',
      },
    },
  },
  robotBox: {
    background: 'rgb(255, 255, 255)',
    cursor: 'pointer',
    height: '100%',
    paddingLeft: '0.25rem',
    borderRadius: '0.625rem',
    backgroundColor: '#ffffff',
    border: 'solid 1px #e4e7eb',
  },
  status: {
    borderRadius: '0.625rem',
    backgroundColor: '#ffffff',
    border: 'solid 1px #e4e7eb',
  },
  robotSelect: {
    '& .MuiAutocomplete-root': {
      '& div': {
        borderRadius: '0.625rem',
        border: 'none',
      },
    },
    '& .makeStyles-inputBox': {
      position: 'relative',
      width: '100%',
      background: '#fff',
      cursor: 'pointer',
      height: '2.563rem',
      border: 'none',
      borderRadius: '0.625rem',
    },
  },

  date: () => ({
    width: '13rem',
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      backgroundColor: '#ffffff',
      border: 'solid 1px #e4e7eb',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Bold',
      fontSize: '1rem',
      letterSpacing: '0',
      color: '#2e4469',
      fontWeight: '500',
      width: '100%',
      height: '2.563rem',
      padding: '0',
      paddingLeft: '1rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'unset',
    },
    '& .MuiIconButton-root': {
      padding: '0',
    },
    '& .MuiInput-underline:before': {
      borderBottom: '0',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '0',
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  }),
  dateError: () => ({
    width: '13rem',
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      backgroundColor: '#ffffff',
      border: 'solid 1px rgb(244, 67, 54)',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Bold',
      fontSize: '1rem',
      letterSpacing: '0',
      color: '#2e4469',
      fontWeight: '500',
      width: '100%',
      height: '2.563rem',
      padding: '0',
      paddingLeft: '1rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'unset',
    },
    '& .MuiIconButton-root': {
      padding: '0',
    },
    '& .MuiInput-underline:before': {
      borderBottom: '0',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '0',
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  }),
  toLine: {
    lineHeight: '2.563rem',
    color: theme.palette.font.white,
    fontSize: 'large',
  },
  errorMsg: {
    color: 'rgb(244, 67, 54)',
    margin: '3px 0rem 0px',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
  },
  robot: {
    height: '2.563rem',
    borderRadius: '0.625rem',
  },
}));
const SearchBar = ({ onClickHandler, dropdownData, robotList, timeslotBookingStatus }) => {
  const classes = searchBarStyle({});

  const [searchFormDate, setSearchFormDate] = useState({
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    startTime: '00:00',
    endTime: '23:59',
    robotId: '',
    status: 0,
  });

  const [errorMsg, setErrorMsg] = useState(null);

  const timeCheck = (value) => {
    if (value === '') {
      return true;
    } else if (value.length === 5 && value[2] === ':') {
      return moment(value, 'HH:mm').isValid();
    }
    return false;
  };

  const dateCheck = (value) => {
    if (value === '') {
      return true;
    } else {
      return moment(value, 'HH:mm').isValid();
    }
  };

  const schema = useMemo(() => {
    return {
      startTime: Yup.string()
        .required(i18n.t('TELEVISIT_ADVANCE_SEARCH_START_TIME_ERROR_MSG'))
        .test('checkStartTime', i18n.t('TELEVISIT_INVALID_DATE_FORMAT'), timeCheck),

      endTime: Yup.string()
        .required(i18n.t('TELEVISIT_ADVANCE_SEARCH_END_TIME_ERROR_MSG'))
        .test('checkEndTime', i18n.t('TELEVISIT_INVALID_DATE_FORMAT'), timeCheck),

      endDate: Yup.string()
        .nullable()
        .required(i18n.t('TELEVISIT_ADVANCE_SEARCH_END_DATE_ERROR_MSG'))
        .test('checkEndDate', i18n.t('TELEVISIT_INVALID_DATE_FORMAT'), dateCheck),

      startDate: Yup.string()
        .nullable()
        .required(i18n.t('TELEVISIT_ADVANCE_SEARCH_START_DATE_ERROR_MSG'))
        .test('checkStartDate', i18n.t('TELEVISIT_INVALID_DATE_FORMAT'), dateCheck),
    };
  }, [searchFormDate]);

  const checkInvalid = (todayFlag, startDate, endDate) => {
    return todayFlag ? moment(startDate, 'HH:mm').isSameOrAfter(moment(endDate, 'HH:mm'), 'minute') : false;
  };
  const checkDateInvalid = (todayFlag, startDate, endDate) => {
    return todayFlag ? false : moment(startDate, 'YYYY-MM-DD').isAfter(moment(endDate, 'YYYY-MM-DD'), 'minute');
  };

  const checkRangeInvalid = (todayFlag, startDate, endDate) => {
    return todayFlag
      ? false
      : moment(startDate, 'YYYY-MM-DD')
          .add(1, 'Y')
          .subtract(1, 'days')
          .isBefore(moment(endDate, 'YYYY-MM-DD'), 'minute');
  };

  const focusCheck = useCallback(
    (name) => {
      return async () => {
        try {
          await checkSubmitData(Yup.object().shape(schema), searchFormDate);
          setErrorMsg(null);
        } catch (e) {
          setErrorMsg(e);
        }
        let startDate = searchFormDate['startDate'];
        let todayFlag = moment(startDate, 'YYYY-MM-DD').isSame(moment(searchFormDate['endDate'], 'YYYY-MM-DD'));

        let invalid = checkInvalid(todayFlag, searchFormDate['startTime'], searchFormDate['endTime']);
        let dateInvalid = checkDateInvalid(todayFlag, startDate, searchFormDate['endDate']);
        let rangeInvalid = checkRangeInvalid(todayFlag, startDate, searchFormDate['endDate']);

        if (invalid) {
          setErrorMsg((oldData) => ({
            ...oldData,
            startTime: i18n.t('ERROR_MSG_START_TIME_CANNO_BE_LATER_THAN_END_TIME'),
          }));
        } else if (dateInvalid) {
          name = name || 'startDate';
          let message =
            name === 'startDate'
              ? i18n.t('TELEVISIT_ADVANCE_SEARCH_START_TIME_CANNO_BE_LATER_THAN_END_TIME_MSG')
              : i18n.t('TELEVISIT_ADVANCE_SEARCH_END_DAY_CANNO_BE_EARLIER_THAN_START_DAY_MSG');
          setErrorMsg((oldData) => ({
            ...oldData,
            [name]: message,
          }));
        } else if (rangeInvalid) {
          name = name || 'startDate';
          setErrorMsg((oldData) => ({
            ...oldData,
            [name]: i18n.t('TELEVISIT_ADVANCE_SEARCH_OVER_MAX_RANGE_ERROR_MSG'),
          }));
        }
      };
    },
    [schema, errorMsg, searchFormDate]
  );

  const checkSubmitData = async (schema, data) => {
    try {
      await schema.validate(data, {
        abortEarly: false,
      });
    } catch (err) {
      const validationErrors = {};
      _.forEach(schema?._nodes, (item) => {
        validationErrors[item] = null;
      });
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path !== undefined) {
            validationErrors[error.path] = error.message;
          }
        });
      }
      throw validationErrors;
    }
  };

  const handleDateChange = useCallback(
    (type) => (value) => {
      if (value === null) {
        value = '';
      }
      if ((type === 'startDate' || type === 'endDate') && value !== '') {
        value = moment(value).format('YYYY-MM-DD');
      }

      if ((type === 'startTime' || type === 'endTime') && value !== '') {
        value = handleTimeChange(value, type, searchFormDate);
      }
      setSearchFormDate((pre) => ({
        ...pre,
        [type]: value,
      }));
    },
    [searchFormDate]
  );

  const handleTimeChange = (value, type, searchFormDate) => {
    if (!/^\\d+$/.test(value)) {
      value = value.replaceAll(/[a-zA-Z]/g, '');
    }

    if (searchFormDate[type].length === 1 && value.length === 2) {
      value += ':';
    }
    if (value.length === 3 && value.indexOf(':') === -1) {
      value = `${value.slice(0, 2)}:${value.slice(2, 3)}`;
    }
    if (value.length > 5) value = value.slice(0, 5);
    return value;
  };

  const handleSearch = () => {
    if (errorMsg) return;
    onClickHandler(searchFormDate);
  };
  const itemList = useMemo(() => {
    return robotList;
  }, [robotList]);

  const statusList = useMemo(() => {
    return timeslotBookingStatus;
  }, [timeslotBookingStatus]);

  return (
    <Box bgcolor="#538fff" borderRadius="10px 10px 0 0" p="0.625rem 1.25rem" height="100%">
      {/* robot box */}
      <Box display="flex" alignItems="center" mb="0.5rem" gridGap="0.5rem">
        <Box className={classes.toLine} mr="0.5rem" width="4rem">
          {i18n.t('SETTING_TELE_TAB_ROBOT')}
        </Box>
        <Box display="flex" alignItems="center" className={classes.robotBox}>
          <img src={RobotImg} className={classes.robot} alt="robot" />
          <AutoCompleteSelect
            height="2.563rem"
            size="small"
            itemList={itemList}
            value={searchFormDate.robotId}
            onChange={handleDateChange('robotId')}
            className={classes.robotSelect}
            placeholder=""
            width="23.5rem"
          />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" height="100%">
        {/* range data box */}
        <Box display="flex" gridGap="0.5rem">
          <Box display="flex" className={classes.toLine} mr="0.5rem" width="4rem">
            {i18n.t('TELEVISIT_POPUP_DATE')}
          </Box>
          <MUIKeyboardDatePicker
            variant="inline"
            ampm={false}
            className={errorMsg?.startDate ? classes.dateError : classes.date}
            value={searchFormDate.startDate}
            onChange={handleDateChange('startDate')}
            format="YYYY-MM-DD"
            maxDate={searchFormDate.endDate}
            minDate={moment(searchFormDate.endDate).subtract(1, 'Y').add(1, 'days')}
            size="small"
            keyboardIcon={<DateIcon className={classes.dateIcon} />}
            inputVariant="outlined"
            width="12rem"
            height="100%"
            onBlur={focusCheck()}
            onClose={focusCheck()}
          />
          <TimeInput
            placeholder={i18n.t('TELEVISIT_SETTING_POPUP_START_TIME')}
            value={searchFormDate.startTime}
            onChange={handleDateChange('startTime')}
            staticData={dropdownData?.staticData}
            height="2.563rem"
            className={errorMsg?.startTime ? classes.timeInputError : classes.timeInput}
            style={{ width: '5.5rem' }}
            onBlur={focusCheck()}
            inputProps={{ value: searchFormDate.startTime }}
          />
          <Box className={classes.toLine}>To</Box>
          <MUIKeyboardDatePicker
            variant="inline"
            ampm={false}
            className={errorMsg?.endDate ? classes.dateError : classes.date}
            value={searchFormDate.endDate}
            minDate={searchFormDate.startDate}
            onChange={handleDateChange('endDate')}
            format="YYYY-MM-DD"
            size="small"
            keyboardIcon={<DateIcon className={classes.dateIcon} />}
            inputVariant="outlined"
            width="12rem"
            onBlur={focusCheck('endDate')}
            onClose={focusCheck('endDate')}
          />

          <TimeInput
            placeholder={i18n.t('TELEVISIT_SETTING_POPUP_END_TIME')}
            value={searchFormDate.endTime}
            onChange={handleDateChange('endTime')}
            staticData={dropdownData?.staticData}
            height="2.563rem"
            className={errorMsg?.endTime ? classes.timeInputError : classes.timeInput}
            style={{ width: '5.5rem' }}
            onBlur={focusCheck('endDate')}
            inputProps={{ value: searchFormDate.endTime }}
          />
        </Box>

        {/* status box */}
        <Box display="flex" gridGap="0.625rem" ml="5.5rem">
          <Box display="flex" className={classes.toLine} mr="0.5rem">
            {i18n.t('TELEVISIT_POPUP_STATUS')}
          </Box>
          <Box className={classes.status}>
            <AutoCompleteSelect
              height="2.563rem"
              size="small"
              itemList={statusList}
              value={searchFormDate.status}
              onChange={handleDateChange('status')}
              className={classNames(classes.robotSelect)}
              placeholder=""
              width="18.5rem"
            />
          </Box>
        </Box>

        {/* Search Box */}
        <Box display="flex" gridGap="0.625rem" ml="0.5rem">
          <Box border="1px solid rgb(228, 231, 235)" borderRadius="0.625rem" bgcolor="#ffffff">
            <StyleButton
              Icon={SearchIcon}
              color="#333333"
              width="6.375rem"
              height="2.563rem"
              p={1}
              onClick={handleSearch}
              borderRadius="0.625rem"
              border="none"
              text={i18n.t('DUTYASSIGN_ROSTER_SEARCH')}
            />
          </Box>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" height="100%">
        <Box display="flex" gridGap="0.5rem">
          <Box display="flex" mr="0.5rem" width="4rem">
            {}
          </Box>
          <Box display="flex" mr="0.5rem" width="13rem" className={classes.errorMsg} textAlign="left">
            {errorMsg?.startDate}
          </Box>
          <Box display="flex" mr="0.5rem" width="7.5rem" className={classes.errorMsg}>
            {errorMsg?.startTime}
          </Box>
          {/* <Box className={classes.toLine}>{}</Box> */}
          <Box display="flex" mr="0.5rem" width="13rem" className={classes.errorMsg}>
            {errorMsg?.endDate}
          </Box>
          <Box display="flex" mr="0.5rem" width="7.5rem" className={classes.errorMsg}>
            {errorMsg?.endTime}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    // height: 620,
  },
  tabs: {
    borderRight: `0px solid ${theme.palette.divider}`,
    '& .MuiTab-textColorPrimary': {
      color: '#7d86a9',
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: '#538fff',
    },
  },
  noRecord: {
    color: 'rgba(0, 0, 0, 0.54)',
    textAlign: 'center',
    top: '15rem',
    fontSize: '2rem',
  },
  tabPanel: {
    '& div:first-child': {
      paddingBottom: '0px',
    },
  },
}));
const AdvancedSearchDialog = ({ handleClose, info }) => {
  const classes = useStyles();
  const [value, setValue] = useState(false);

  const [systemNameData, setSystemNameData] = useState([]);
  const [timeslotBookingStatus, setTimeslotBookingStatus] = useState();
  const [dropdownData, setDropdownData] = useState(null);
  const language = useSelector((state) => state.settings.language);
  const [robotList, setRobotList] = useState([]);

  const getRobotListApi = useCallback(async () => {
    try {
      const { result } = await teleVisitAPI.getRobotListAll();
      let baseData = [{ text: language === 'en-us' ? 'All' : '全部', value: '' }];
      const robotData = _.map(result, (item) => {
        let text = '';
        if (item.robotStatus === TELEVISIT_ROBOT_STATUS.UNAVAILABLE) {
          text = ` ${i18n.t('TELEVISIT_OUT_OF_SERVICE')}`;
        }
        if (
          item.robotStatus !== TELEVISIT_ROBOT_STATUS.UNAVAILABLE &&
          item.robotStatus !== TELEVISIT_ROBOT_STATUS.AVAILABLE
        ) {
          text = ` (${i18n.t('TELEVISIT_SETTING_POPUP_DISCONNECTED')})`;
        }

        return {
          text: item.robotName + text,
          value: item.robotId,
        };
      });
      setRobotList(_.concat(baseData, robotData));
    } catch (error) {}
  }, []);
  const getStaticData = useCallback(async () => {
    try {
      const { result } = await teleVisitAPI.getStaticDataList();
      setDropdownData(result);
      const systemNameData = _.filter(
        result.staticData,
        (item) => item.dataKey === 'SystemName' && item.dataType === 'Environment'
      );

      // booking status
      const timeslotBookingStatusData = _.filter(
        result.statusData,
        (item) =>
          item.dataKey === 'TimeslotBookingStatus' &&
          item.dataType === 'DropDown' &&
          item.dataValue !== '0' &&
          item.dataValue !== '1' &&
          item.dataValue !== '2'
      );

      timeslotBookingStatusData.push({
        dataType: 'DropDown',
        dataKey: 'TimeslotBookingStatus',
        dataValue: 0,
        descCH: '全部',
        descEN: 'All',
        displaySeq: 0,
      });

      const statusList = _.sortBy(
        _.map(timeslotBookingStatusData, (item) => ({
          text: getStatusText(item),
          value: item.dataValue,
          displaySeq: item.displaySeq,
        })),
        ['displaySeq']
      );

      setSystemNameData(systemNameData);
      setTimeslotBookingStatus(statusList);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getStatusText = (item) => {
    let status = Number(item.dataValue);
    let statusText = '';
    switch (status) {
      case TELEVISIT_STATUS.CONFIRMED:
        statusText = i18n.t('TELEVISIT_STATUS_CONFIRMED_SCHEDULED');
        break;
      case TELEVISIT_STATUS.INPROGRESS:
        statusText = i18n.t('TELEVISIT_STATUS_VISIT_IN_PROGRESS');
        break;
      case TELEVISIT_STATUS.COMPLETED:
        statusText = i18n.t('TELEVISIT_STATUS_VISIT_COMPLETED');
        break;
      case TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING:
        statusText = i18n.t('TELEVISIT_STATUS_ROBOT_STARTS_PROCESS_THE_BOOKING');
        break;
      case TELEVISIT_STATUS.RESERVED:
        statusText = i18n.t('TELEVISIT_STATUS_VERIFYING');
        break;
      case TELEVISIT_STATUS.CANCEL:
        statusText = i18n.t('TELEVISIT_CANCELLED');

        break;
      case TELEVISIT_STATUS.COMPLETED_MANUALLY:
        statusText = i18n.t('TELEVISIT_STATUS_VISIT_COMPLETED_MANUALLY');
        break;
      case TELEVISIT_STATUS.REJECTED:
        statusText = i18n.t('TELEVISIT_STATUS_VISIT_REJECTED');
        break;
      default:
        statusText = language === 'en-us' ? item.descEN : item.descCH;
        break;
    }
    return statusText;
  };

  useEffect(() => {
    debouncedSearch({
      ...oriPage,
      ...searchFormDate,
    });
  }, []);

  useEffect(() => {
    getRobotListApi();
  }, [getRobotListApi]);

  useEffect(() => {
    getStaticData();
  }, [getStaticData]);

  // search
  const oriPage = {
    pageNo: 1,
    pageSize: 30,
  };
  const [page, setPage] = useState({
    ...oriPage,
  });
  const [searchFormDate, setSearchFormDate] = useState({
    startDate: moment(),
    endDate: moment(),
    startTime: '00:00',
    endTime: '23:59',
    robotId: '',
    status: 0,
  });

  const [itemList, setItemList] = useState([]);
  const [searchResult, setSearchResult] = useState({ data: [], count: -1 });
  const [dialogInfo, setDialogInfo] = useState({});

  const isMaxCount = useMemo(() => itemList.length >= searchResult.count, [itemList, searchResult]);

  const handleChange = useCallback(
    (event, newValue) => {
      if (value === newValue) {
        return false;
      }
      setValue(newValue);
      setDialogInfo({
        ...dialogInfo,
        bookId: newValue,
      });
    },
    [value,dialogInfo]
  );

  const search = useCallback(
    async (params) => {
      params = {
        ...params,
        startDate: moment(`${moment(params.startDate).format('yyyy-MM-DD').toString()} ${params.startTime}`).format(
          'x'
        ),
        endDate: moment(`${moment(params.endDate).format('yyyy-MM-DD').toString()} ${params.endTime}`).format('x'),
      };

      if (isMaxCount && params.pageNo > 1) return;

      const res = await teleVisitAPI.getTimeslotSearch(params);

      const data = _.cloneDeep(res.result?.data || []);

      setPage({
        ...page,
        pageNo: params.pageNo,
      });
      setValue(false);
      setItemList(params.pageNo <= 1 ? [...data] : [...itemList, ...data]);
      setValue(data.length > 0 ? data[0].bookId : false);
      setDialogInfo({
        ...dialogInfo,
        bookId: data.length > 0 ? data[0].bookId : null,
        timeslotBookingStatusEnum: data.length > 0 ? data[0].timeslotBookingStatusEnum : 0,
      });
      setSearchResult(res.result);
    },
    [page, searchFormDate]
  );

  const debounceSearchHandle = useRef();
  debounceSearchHandle.current = async (...arg) => {
    search(...arg);
  };

  const debouncedSearch = useCallback(
    _.debounce((...arg) => debounceSearchHandle.current(...arg), 500),
    [debounceSearchHandle]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // search button clickHandler
  const onClickHandler = useCallback(
    (e) => {
      setSearchFormDate(e);
      debouncedSearch({
        ...oriPage,
        ...e,
      });
    },
    [debouncedSearch, page, searchFormDate]
  );

  // page button handler
  const pageHandler = (e) => {
    const newPage = {
      ...page,
      pageNo: page.pageNo + 1,
    };
    debouncedSearch({
      ...newPage,
      ...searchFormDate,
    });
    setPage(newPage);
  };

  const sytemNameMaping = (value) => {
    return _.map(systemNameData, (data) => {
      if (data.dataValue === value) return language === 'en-us' ? data.descEN : `${data.descCH}`;
    });
  };

  return (
    <DiaLog
      open={true}
      width="90.813rem"
      p="2.375rem 1.938rem 1.875rem"
      height="100%"
      title={i18n.t('TELEVISIT_ADVANCE_SEARCH')}
      handleClose={handleClose}
      haveFoot={false}
    >
      <div display="flex">
        <SearchBar
          onClickHandler={onClickHandler}
          searchFormDate={searchFormDate}
          dropdownData={dropdownData}
          robotList={robotList}
          timeslotBookingStatus={timeslotBookingStatus}
        />
      </div>

      <Box className={classes.root}>
        <Box display="flex" flexDirection="column" flexBasis="22%" height="600px">
          <StyledScrollTabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            textColor="primary"
            scrollButtons={searchResult.count <= 0 ? 'off' : 'on'}
            // action={tabAction}
          >
            {itemList.map((item, index) => (
              <Tab
                key={item.bookId}
                value={item.bookId}
                label={<Content item={item} sytemNameMaping={sytemNameMaping} />}
                {...a11yProps(item.bookId)}
              />
            ))}
            {!isMaxCount && <Button onClick={pageHandler}>{`${i18n.t('TELEVISIT_SETTING_MORE')}...`}</Button>}
          </StyledScrollTabs>
        </Box>
        <Box display="flex" flexDirection="column" flexBasis="49%">
          <TabPanel value={value} index={0} className={classes.tabPanel}>
            {value && dialogInfo.bookId && <TimeslotDetail info={dialogInfo} />}
            {searchResult.count === 0 && (
              <Box width="100%" className={classes.noRecord} color="red" pt="200px" height="468px">
                {i18n.t('TELEVISIT_CANCLELIST_NO_RECORD')}
              </Box>
            )}
          </TabPanel>
        </Box>
      </Box>
    </DiaLog>
  );
};

const StyledScrollTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    paddingTop: '6px',
    paddingBottom: '12px',
    '& > span': {
      width: '100%',
      backgroundColor: '#ff8181',
    },
  },
  scrollButtons: {
    height: '18px',
  },
})((props) => <ScrollTabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export default AdvancedSearchDialog;
